<template>
    <GgmsInput
        v-model="password"
        @update:modelValue="$emit('update:modelValue', password)"
        :showRequired="showRequired"
        :iconEnd="passwordInputIcon"
        :type="passwordInputType"
        :name="name"
        :label="label"
        :required="required"
        :autocomplete="autocomplete"
        :invalid="invalid"
        :errorMessage="errorMessage"
        :disabled="disabled"
        :showIconEnd="true"
        @clickIconEnd="togglePasswordVisibility"
    />
</template>

<script lang="ts" setup>
import { computed, ref, withDefaults } from "vue"
import GgmsInput from "@/components/GgmsInput.vue"
import { EyeIcon, EyeOffIcon } from "@heroicons/vue/solid"

interface Props {
    modelValue?: string
    label?: string
    required?: boolean
    name?: string
    autocomplete?: string
    invalid?: boolean
    errorMessage?: string
    showRequired?: boolean
    disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    modelValue: "",
    label: "Password",
    name: "password",
    autocomplete: "current-password",
    required: false,
    showRequired: true,
})

defineEmits(["update:modelValue"])

const password = ref(props.modelValue)
const showPassword = ref(false)

const passwordInputType = computed(() => {
    return showPassword.value ? "text" : "password"
})

const passwordInputIcon = computed(() => {
    return password.value?.length ? (showPassword.value ? EyeOffIcon : EyeIcon) : undefined
})

function togglePasswordVisibility() {
    showPassword.value = !showPassword.value
}
</script>
